export default __webpack_public_path__ + "static/media/CenterOpening.e13cca72.jpg";